export default __webpack_public_path__ + "static/KeepWCBeautifulColorLogo-2eeae3aa346064e9da7261cca45070d3.svg";